import { render, staticRenderFns } from "./FinalPrevPoliciesQuestion.vue?vue&type=template&id=243631e7&scoped=true"
import script from "./FinalPrevPoliciesQuestion.vue?vue&type=script&lang=js"
export * from "./FinalPrevPoliciesQuestion.vue?vue&type=script&lang=js"
import style0 from "./FinalPrevPoliciesQuestion.vue?vue&type=style&index=0&id=243631e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243631e7",
  null
  
)

/* custom blocks */
import block0 from "./FinalPrevPoliciesQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports